import type { EntityConfig } from "../hooks/useEntity";

export const snackSpotEntityConfig: EntityConfig = {
  name: "SnackSpot",
  orderBy: "created_at DESC",
  properties: {
    userId: { type: "integer", description: "Owner user ID" },
    label: { type: "string", description: "Spot name" },
    phone: { type: "string", description: "Direct phone line" },
    deliveryUrl: { type: "string", description: "Preferred ordering link" },
    locationHint: { type: "string", description: "Neighborhood or cross streets" },
    notes: { type: "string", description: "Saved order notes" },
    favorite: { type: "number", description: "1 when pinned as favorite" },
    lastOrderedAt: { type: "string", format: "date", description: "ISO timestamp for last order" },
    tags: { type: "string", description: "JSON string of labels" },
  },
  required: ["userId", "label"],
};
